import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getTransportPriceList = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportPriceList
);

export const getTransportPriceListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportPriceListLoading
);

export const getTransportPriceListError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportPriceListError
);

export const getTransportPrice = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportPriceList
);

export const getTransportPriceLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportPriceListLoading
);

export const getTransportPriceError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportPriceListError
);

export const getDiscountedTransportCharge = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.discountedTransportPriceList
);

export const getDiscountedTransportChargeLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.discountedTransportPriceListLoading
);

export const getDiscountedTransportChargeError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.discountedTransportPriceListError
);

export const createDiscountedTransportChargeSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.createDiscountedTransportPriceSuccess
);

export const createDiscountedTransportChargeLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.createDiscountedTransportPriceLoading
);

export const createDiscountedTransportChargeError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.createDiscountedTransportPriceError
);

export const getCreatedTransportCharge = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.createdDiscountedTransportPrice
);

export const updateDiscountedTransportChargeSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.updateDiscountedTransportPriceSuccess
);

export const updateDiscountedTransportChargeLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.updateDiscountedTransportPriceLoading
);

export const updateDiscountedTransportChargeError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.updateDiscountedTransportPriceError
);

export const getTransportOptions = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportOptions
);

export const getTransportOptionsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportOptionsLoading
);

export const getTransportOptionsError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportOptionsError
);

export const getTransportLoads = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportLoads
);

export const getTransportLoadsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportLoadsLoading
);

export const getTransportLoadsError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportLoadsError
);

export const getTransportLoadsPurchase = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportLoadsPurchase
);

export const getTransportLoadsPurchaseLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportLoadsPurchaseLoading
);

export const getTransportLoadsPurchaseError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportLoadsPurchaseError
);

export const getTransportAreas = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportAreas
);

export const getTransportAreasLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportAreasLoading
);

export const getTransportAreasError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportAreasError
);

export const getTransportDistricts = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportDistricts
);

export const getTransportDistrictsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportDistrictsLoading
);

export const getTransportDistrictsError = createSelector(
  getKwikspaceAppState,
  (state) => state.transport.transportDistrictsError
);